import React, { useEffect, useState, Fragment } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormProvider, useForm } from 'react-hook-form'
import { useMutation, useQuery } from '@apollo/client'
import Box from '../../../../../Global/Box'
import InputController from '../../../../../Global/InputController'
import { toastSweetAlert } from '../../../../../Helpers/ToastSweetAlert'
import { useLoading } from '../../../../../../LoadingOverlay/LoadingOverlayContext'
import {
  findArrayStatus,
  fnNextStatusArrayAllowed,
  fnObjNameStatus,
} from '../../../../../../const/constStatuses_waterTruckRequest'
import { GenerateYupValidator } from './GenYupValidator/GenerateYupValidator'
import {
  CancelFields,
  ValidationFields,
  CompletedFields,
} from './Helper/FieldStatus'
import { CHANGE_STATUS_WATER_TRUCK } from '../../../../../../graphql/Catalog/WaterTruckRequest/waterTruckRequest'

import { categorModule } from '../../WaterTruckRequest'
import { GET_ALL_CANCELLATION_REASON_BY_TYPE } from '../../../../../../graphql/Catalog/CancellationReason/CancellationReason'
const allStatus = fnObjNameStatus()

const ModalStatus = ({ id, dataMain, refetchMain, setCloseModal }) => {
  const { showLoading, hideLoading } = useLoading()

  //STATE
  const [fieldsSchema, setFieldsSchema] = useState({})
  const [fieldsToRender, setFieldsToRender] = useState([])
  const [statusSelected, setStatusSelected] = useState(null)
  const [optionsStatus, setOptionsStatus] = useState([])
  const [optionsReasons, setOptionsReasons] = useState([])
  const [files, setFiles] = useState([])
  const [currentStatus, setCurrentStatus] = useState()

  useEffect(() => {
    const current = findArrayStatus(dataMain.status_id)
    const options = fnNextStatusArrayAllowed(current.arrayNextStatus)
    setCurrentStatus(current)
    setOptionsStatus(options)
    setStatusSelected(current.id)
  }, [dataMain])

  //SCHEMA
  const schema = fieldsSchema

  const {
    methods,
    handleSubmit,
    control,
    formState: { errors },
    reset,
    setValue,
    getValues,
  } = useForm({
    resolver: yupResolver(schema),
  })

  const {
    loading: loadingReasons,
    error: errorReasons,
    data: dataReasons,
  } = useQuery(GET_ALL_CANCELLATION_REASON_BY_TYPE, {
    variables: {
      type: categorModule,
      limit: null,
      offset: null,
      searchQuery: null,
    },
    fetchPolicy: 'no-cache',
  })

  const [changeStatus] = useMutation(CHANGE_STATUS_WATER_TRUCK)

  useEffect(() => {
    try {
      if (loadingReasons) return
      if (errorReasons) {
        return toastSweetAlert({
          mode: 'error',
          message: errorReasons.message,
        })
      }
      const cancelReasons = dataReasons.getAllCancellationReasonByType.rows.map(
        (reason) => {
          return {
            value: reason.id,
            label: reason.reason,
          }
        }
      )
      setOptionsReasons(cancelReasons)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataReasons, loadingReasons, errorReasons])

  const handleDrop = (e) => {
    e.preventDefault()
    if (files.length >= 5)
      return toastSweetAlert({
        mode: 'error',
        message: 'Solo puedes subir 5 archivos',
      })

    const file = e.dataTransfer.files[0]

    const firstType = file.type.split('/')[0]
    const getType = file.type.split('/')[1]

    const allowedTypes = ['png', 'jpeg', 'jpg', 'pdf']

    if (!allowedTypes.includes(getType)) {
      return toastSweetAlert({
        mode: 'error',
        message: 'Este tipo de archivo no esta permitido',
      })
    }

    const allowedSize = 1024 * 1024 * 5

    if (file.size > allowedSize) {
      return toastSweetAlert({
        mode: 'error',
        message: 'El archivo es muy grande',
      })
    }

    const newFiles = [...e.dataTransfer.files]
    setFiles((prevFiles) => [
      ...prevFiles,
      ...newFiles.slice(0, 5 - prevFiles.length),
    ])
  }

  const handleDragOver = (e) => {
    e.preventDefault()
  }

  const handleRemoveFile = (index) => {
    const newFiles = files.filter((file, i) => i !== index)
    setFiles(newFiles)
  }

  const onSubmit = async (Data) => {
    showLoading()
    try {
      let input = {
        id: +dataMain.id,
        statusIdNext: +Data.status,
        planning_date: Data?.planning_date ? Data.planning_date : null,
        comments_internal: Data.comments_internal,
        comments: Data.comments,
        cancel_reason: Data.cancel_reason ? +Data.cancel_reason : null,
        attatchments: files,
      }

      await changeStatus({ variables: { input } })

      await refetchMain()
      setStatusSelected(null)
      reset()
      await cleanFields()
      setCloseModal(true)
      return toastSweetAlert({
        mode: 'ok',
        message: 'Estado cambiado correctamente',
      })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  const cleanFields = async () => {
    setFiles([])
    setFieldsSchema({})
    setFieldsToRender([])
    return true
  }

  useEffect(() => {
    /* if (statusSelected === allStatus.comunicar_solucionado) {
      const fields = GenerateYupValidator({
        fields: FieldsNew,
      })
      setFieldsSchema(fields)
      setFieldsToRender(FieldsNew)
      return true
    } */

    if (statusSelected === allStatus.validacion) {
      const fields = GenerateYupValidator({
        fields: ValidationFields,
      })
      setFieldsSchema(fields)
      setFieldsToRender(ValidationFields)
      return true
    }

    if (statusSelected === allStatus.completado) {
      const fields = GenerateYupValidator({
        fields: CompletedFields,
      })
      setFieldsSchema(fields)
      setFieldsToRender(CompletedFields)
      return true
    }

    if (statusSelected === allStatus.cancelado) {
      const fields = GenerateYupValidator({
        fields: CancelFields,
      })
      setFieldsSchema(fields)
      setFieldsToRender(CancelFields)
      return true
    }
  }, [statusSelected])

  const handleStatusChange = async (e) => {
    await cleanFields()
    setStatusSelected(e.value)
  }

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            withCard={false}
            btnSubmit
            content={
              <>
                <div className="row">
                  <div className="col-12">
                    <h6>Estado actual: {currentStatus?.labelMain}</h6>
                    <br />
                  </div>
                  {fieldsToRender &&
                    fieldsToRender.length > 0 &&
                    fieldsToRender.map((field, index) => {
                      return (
                        <Fragment key={index}>
                          {field.name === 'status' ? (
                            <div className={`col-12 p-2`}>
                              <div className="col-lg-6">
                                <InputController
                                  name={field.name}
                                  control={control}
                                  label={field.label}
                                  inputType={field.inputType}
                                  options={optionsStatus}
                                  menuPosition="fixed"
                                  placeholderTxt="Selecciona un estado"
                                  changeAction={(e) => handleStatusChange(e)}
                                />
                              </div>
                            </div>
                          ) : field.inputType === 'choosen' ? (
                            <div
                              className={`col-sm-${field.colSize} col-md-${field.colSize} p-3 card`}
                            >
                              <div className="card-body">
                                <InputController
                                  name={field.name}
                                  control={control}
                                  label={field.label}
                                  inputType={field.inputType}
                                  placeholderTxt={`Selecciona un ${field.label}`}
                                  options={
                                    field.name === 'manager_group'
                                      ? [
                                          {
                                            value: 1,
                                            label: 'Falta validar campos',
                                          },
                                        ]
                                      : optionsReasons
                                  }
                                  menuPosition="fixed"
                                  changeAction={() => {}}
                                />
                              </div>
                            </div>
                          ) : field.inputType === 'date' ? (
                            <div
                              className={`col-sm-${field.colSize} col-md-${field.colSize} card`}
                            >
                              <div className="card-body">
                                <InputController
                                  name={field.name}
                                  control={control}
                                  label={field.label}
                                  type={field.inputType}
                                />
                              </div>
                            </div>
                          ) : field.inputType === 'textarea' ? (
                            <div
                              className={`col-sm-${field.colSize} col-md-${field.colSize} col-lg-${field.colSize} card p-3`}
                              style={{
                                marginLeft: '10px',
                                minWidth: '48%',
                              }}
                            >
                              <div className="card-body">
                                <InputController
                                  placeholderTxt={field.label}
                                  name={field.name}
                                  control={control}
                                  label={`${field.label}`}
                                  inputType={field.inputType}
                                />
                              </div>
                            </div>
                          ) : (
                            field.inputType === 'attachments' && (
                              <div
                                className="card col-12"
                                style={{ padding: '20px' }}
                              >
                                {/* Área de arrastrar y soltar */}
                                <div
                                  className="col-12"
                                  style={{
                                    border: '2px dashed #ccc',
                                    padding: '20px',
                                    textAlign: 'center',
                                    borderRadius: '10px', // Bordes redondeados
                                    backgroundColor: '#f9f9f9', // Fondo claro
                                  }}
                                  onDrop={handleDrop}
                                  onDragOver={handleDragOver}
                                  accept
                                >
                                  <div className="card-body">
                                    <p>Arrastra y suelta archivos aquí</p>
                                    {/* Vista previa de archivos subidos */}
                                    {files.length > 0 && (
                                      <div style={{ marginTop: '20px' }}>
                                        <h4>Archivos subidos:</h4>
                                        <div
                                          style={{
                                            display: 'flex',
                                            flexWrap: 'nowrap',
                                          }}
                                        >
                                          {files.map((file, index) => (
                                            <div
                                              key={index}
                                              style={{
                                                textAlign: 'center',
                                                position: 'relative',
                                                gap: '5px',
                                                border: '1px solid #ccc',
                                                borderRadius: '5px',
                                              }}
                                            >
                                              <button
                                                onClick={() =>
                                                  handleRemoveFile(index)
                                                }
                                                style={{
                                                  position: 'absolute',
                                                  top: '5px',
                                                  right: '5px',
                                                  background: '#ff4d4d',
                                                  color: '#fff',
                                                  border: 'none',
                                                  borderRadius: '50%',
                                                  width: '24px',
                                                  height: '24px',
                                                  cursor: 'pointer',
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'center',
                                                  fontSize: '12px',
                                                }}
                                              >
                                                ×
                                              </button>

                                              {file.type.split('/')[0] ===
                                              'image' ? (
                                                <img
                                                  src={URL.createObjectURL(
                                                    file
                                                  )} // Muestra la vista previa
                                                  alt={file.name}
                                                  style={{
                                                    width: '50px',
                                                    height: '50px',
                                                    objectFit: 'cover',
                                                    borderRadius: '5px',
                                                  }}
                                                />
                                              ) : (
                                                <span
                                                  style={{
                                                    fontSize: '40px',
                                                    color: '#ff4d4d',
                                                  }}
                                                >
                                                  {' '}
                                                  <i
                                                    className={`far fa-file-${
                                                      file.type.split('/')[1]
                                                    }`}
                                                  ></i>
                                                </span>
                                              )}
                                              <p
                                                style={{
                                                  fontSize: '12px',
                                                  wordBreak: 'break-all',
                                                }}
                                              >
                                                {file.name}
                                              </p>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    )}
                                  </div>

                                  {/* Texto de formatos y límite de archivos */}
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      marginTop: '10px',
                                      fontSize: '14px',
                                      color: '#666',
                                    }}
                                  >
                                    <p>
                                      Formatos permitidos: .png, .jpeg, .jpg y
                                      .pdf - Tamaño máximo: 5MB
                                    </p>
                                    <p>{files.length}/5 archivos</p>
                                  </div>
                                </div>
                              </div>
                            )
                          )}
                        </Fragment>
                      )
                    })}
                </div>
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}

export default ModalStatus
